export default __webpack_public_path__ + "static/media/article_black_24dp.12440c92.svg";